<template>
  <n-config-provider :locale="zhCN" :date-locale="dateZhCN">
    <RouterView></RouterView>
  </n-config-provider>
</template>

<script>

import {dateZhCN, zhCN} from "naive-ui";
import "@/utils/messageUtils.js"

export default {
  name: "IndexComponent",
  data() {
    return {
      dateZhCN,
      zhCN
    }
  },
}
</script>

<style scoped>

</style>